import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteEmployee, updateEmployee } from '../actions';

const EmployeeItem = ({ employee }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState(employee.Email);
  return (
    <tr key={employee.ID}>
      <td>{employee.Name}</td>
      {employee.Email !== undefined && employee.Email !== '' ? (
        <td>{employee.Email}</td>
      ) : (
        <td>
          <input
            type="text"
            name="email"
            style={{ width: '200px' }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          &nbsp;&nbsp;
          <button
            onClick={() => {
              employee.Email = email;
              dispatch(updateEmployee(employee));
            }}
          >
            Add Email
          </button>
        </td>
      )}
      <td>
        <button
          onClick={() => {
            if (
              window.confirm(
                'Are you sure to delete employee: ' + employee.Name + '?',
              )
            ) {
              dispatch(deleteEmployee(employee.ID));
            }
          }}
        >
          Delete
        </button>
      </td>
    </tr>
  );
};

export default EmployeeItem;
